import styled, { css } from 'styled-components';

import { RowCentered } from 'pages/Login/style';
import { pxToRem } from 'utils/scss';
import { SelectWrapper } from 'ui/atoms/DropDown/style';

export const ForgotPasswordTitle = styled.div`
  padding-top: ${pxToRem('70px')};
  color: ${props => props.theme.colors.white};
  display: flex;
  justify-content: center;
`;
export const TCText = styled.div`
  width: 100%;
  text-align: center;
  color: white;
  font-size: ${pxToRem('14px')};
  line-height: 1.57;
  font-weight: 600;
`;

export const ErrorWrapper = styled(RowCentered)`
  padding-top: ${pxToRem('16px')};
  padding-bottom: ${pxToRem('16px')};

  ${props =>
    props.createPassword &&
    css`
      padding-top: ${pxToRem('55px')};
      padding-bottom: ${pxToRem('0px')};
    `}
`;

export const PhoneSection = styled.div`
  border-radius: ${pxToRem('6px')};
  margin-top: ${pxToRem('24px')};
  height: ${pxToRem('59px')};

  ${props =>
    props.status === 'invalid'
      ? `border: ${pxToRem('1px')} solid ${props.theme.colors.redError}`
      : `border: ${pxToRem('1px')} solid rgba(255, 255, 255, 0.8)`};
  background-color: rgba(255, 255, 255, 0.32);
  padding: ${props =>
    props.editingPersonalData ? pxToRem('0') : pxToRem('8')};
  display: flex;

  ${props =>
    props.editingPersonalData &&
    !props.isOnLoginFlow &&
    css`
            justify-content: center;
            align-items: center;
            margin-left: ${pxToRem('10px')}
            padding-top: ${pxToRem('32px')};
          `}

  &>div {
    :is(:first-child) {
      width: 30%;

      ${props =>
        !props.isOnLoginFlow &&
        css`
          height: ${pxToRem('56px')};
        `}
    }
  }

  & ${SelectWrapper} {
    & .Select__menu {
      > div {
        max-height: ${pxToRem('200px')};
      }
    }
  }
`;
